module.exports = __webpack_public_path__ + "img/photo-album-test-05.96464510.png";